'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, createContext, useContext } from 'react';
import { E2E } from '@src/constants/E2ETestIDs';
type Context = {
  testIdPrefix: string;
  getTestId: (prefix: string, elementId: string, description?: string) => string;
  E2E: typeof E2E;
};
type ProviderProps = {
  testIdPrefix: Context['testIdPrefix'];
  children: ReactNode;
};
const Context = createContext({
  testIdPrefix: '',
  getTestId: () => '',
  E2E
} as Context);
export const useE2ETesting = () => {
  return useContext(Context);
};
export const getTestId = (prefix: string, elementId: string, description?: string) => {
  if (prefix && elementId) {
    return `${prefix}_${elementId}${description ? `_${description}` : ''}`;
  }
  return '';
};
export const E2ETestingProvider = t0 => {
  const $ = _c(5);
  const {
    children,
    testIdPrefix
  } = t0;
  let t1;
  if ($[0] !== testIdPrefix) {
    t1 = {
      testIdPrefix,
      getTestId,
      E2E
    };
    $[0] = testIdPrefix;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <Context.Provider value={t1}>{children}</Context.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const normalizeTestSlug = (slug: string) => {
  const words = slug.split('-');
  const camelCased = words[0] + words.slice(1).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('');
  return camelCased;
};